define('views/lib/Podio.Views.SideTabsBadgeCount',['require','underscore','jquery','lib/backbone/Backbone.PodioView','jst!filefinder/_badge_count'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstBadgeCount = require('jst!filefinder/_badge_count');

  return ViewPodioBase.extend({
    initialize : function(options) {
      _.bindAll(this, 'render');

      this.elm = $(this.el);
      this.eventBridge = options.eventBridge;
      this.count = options.count || 0 ;

      this.isSelected = options.isSelected;

      this.color = options.color;

      if (this.color === 'blue') {
        this.className = 't-badge-count-blue';
      }

      if (this.color === 'dark') {
        this.className = 't-badge-count-dark';
      }

      if (this.color === 'grey') {
        this.className = 't-badge-count-grey';
      }

    },

    render : function() {
      this.htmlBadge = this.getTemplate(jstBadgeCount, {
        count : this.count,
        className: this.className
      });

      this.elm.html(this.htmlBadge);

      return this;
    },

    dispose: function() {
      this.remove();
    }
  });

});

